import { mapDTO } from '@twistezo/ts-dto-mapper'

import { floatPercentFromDTO } from 'utils/number'
import { DomainPriceGenius } from '../../types/DomainPriceGenius'
import { DomainPriceGeniusDTO } from '../types/domainPriceGeniusDTO'

export const domainPriceGeniusFromDTO = (from: DomainPriceGeniusDTO) =>
  mapDTO<DomainPriceGeniusDTO, DomainPriceGenius>({ from }).transform(domainPriceGeniusDTO => {
    const { createdAt, trafficPercent, updatedAt } = domainPriceGeniusDTO

    return {
      ...domainPriceGeniusDTO,
      createdAt: new Date(createdAt),
      trafficPercent: floatPercentFromDTO(trafficPercent),
      updatedAt: new Date(updatedAt),
    }
  })
